import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import { CtaButton } from '../styled';

import wechatImg from '../../images/wechat.svg';
import wechatQrcodeImg from '../../images/wechatQrcode.png';


const FooterContainer = styled.div`
  bottom: 0;
  background: #f5f5f5;
  font-size: 14px;
`;

const FooterInner = styled.div`
  margin: 0 auto;
  max-width: 95%;

  @media (min-width: 992px) {
    max-width: 796px;
  }
`;




const FooterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  height: 71px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  color: #888888;

  &:last-child {
    border: none;
  }

  &.top {
    @media(max-width: 645px) {
      padding: 20px 0;
      height: auto;
    }
  }
`;

const NavContainer = styled.div`
  display: flex;
`;

const NavItem = styled.div`
  margin: 0 10px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const NavItemLink = styled.a`
  text-decoration: none;
  color: #888888;
`;

const SocialIcon = styled.div`
  margin: 0 6px;

  img {
    width: 24px;
    margin: 0;

    &:hover {
      cursor: pointer;
    }
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &.wechat {
    position: relative;
    display: inline-block;

    &:hover .wechatQrcode {
      visibility: visible;
    }
  }
`;

const WechatQrCode = styled.div`
    visibility: hidden;
    left: -50px;
    top: -130px;
    width: 100px;
    height: 100px;
    background-color: #fff;
    text-align: center;
    border: 1px solid;
    border-radius: 6px;
    padding: 10px;
    position: absolute;
    z-index: 1;

    img {
      width: 100px;
    }
`;

const ContactUsButton = styled(CtaButton)`
  background-color: #e4e4e4;
  color: #888888;
  height: 32px;
  width: 110px;
  font-weight: 500;
  text-transform: initial;
  line-height: 31px;

  @media(max-width: 645px) {
    margin-top: 16px;
  }
`;

function Footer(props) {
  const footerRes = useStaticQuery(graphql`
    query FooterQuery {
      prismicFooter {
        data {
          page_links {
            label
            link {
              url
            }
          }
          social_links {
            icon {
              url
            }
            link {
              url
            }
          }
        }
      }
    }
  `);
  // const pathName = props.path;
  const footerData = footerRes.prismicFooter.data;

  const pageLinks = footerData.page_links;
  const socialLinks = footerData.social_links;
  // const tcnhSocialLinks = footerData.tcnh_social_links;

  return (
    <FooterContainer>
      <FooterInner>
        <FooterRow className="top">
          <NavContainer>
            {pageLinks.map((pageLink, index) => {
              return (
                <NavItem key={index}>
                  <NavItemLink href={pageLink.link.url}>{pageLink.label}</NavItemLink>
                </NavItem>
              );
            })}
          </NavContainer>
          <div><a href="mailto: support@trueusd.com"><ContactUsButton>Contact Us</ContactUsButton></a></div>
        </FooterRow>
        <FooterRow>
          <div>&copy; 2023 TrueUSD. All rights reserved.</div>
          <NavContainer>
            {socialLinks.map((socialLink, index) => {
              return (
                <SocialIcon key={index}>
                  <a href={socialLink.link.url} target="_blank" rel="noopener noreferrer"><img src={socialLink.icon.url} /></a>
                </SocialIcon>
              );
            })}

            <SocialIcon className="wechat" >
              <img src={wechatImg} alt=""/>
              <WechatQrCode className="wechatQrcode">
                <img src={wechatQrcodeImg} alt=""/>
              </WechatQrCode>
            </SocialIcon>
          </NavContainer>
        </FooterRow>
      </FooterInner>
    </FooterContainer>
  );
}

export { Footer };
